import { IProduct, IProductOption } from "@/types/types";

export const buildProductUrl = (productId: number|string, slug: string): string => `/items/${slug}/?id=${productId}`;
export const buildProductShopUrl = (product: IProduct): string => `/shop/products/${product.slug}/?id=${product.id}`;

export function formatRemainingTime(expiresAt: string | Date): string {
  const now = new Date();
  const end = new Date(expiresAt);
  const diffMs = end.getTime() - now.getTime();

  if (diffMs <= 0) return 'Ended';

  const totalMinutes = Math.floor(diffMs / 60000);
  const days = Math.floor(totalMinutes / 1440);
  const hours = Math.floor((totalMinutes % 1440) / 60);
  const minutes = totalMinutes % 60;

  let result = 'Ends in ';
  if (days > 0) result += `${days}d `;
  if (hours > 0) result += `${hours}h `;
  if (days === 0 && minutes > 0) result += `${minutes}m`;

  return result.trim();
}

export function formatDate(date: string | Date): string {
  const d = new Date(date);
  return d.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function getUserCartLocalStorageKey(userId: number | string): string {
    return `w_user_${userId}_cart`;
}

export function getProductOptionByType(options: IProductOption[], type: string): IProductOption | undefined {
  return options.find(option => option.type.toLowerCase() === type.toLowerCase());
}